import { reactive } from "vue";

export const accountState = reactive({
  currentAccountId: undefined,
});
